{
	"sort": {
		"newest": "Uusimmat ensin",

		"priceAsc": "Hinta: halvin ensin",

		"priceDesc": "Hinta: kallein ensin",

		"label": "Järjestys"
	},

	"header": {
		"tag": "Markkinapaikka",

		"title": "Selaa ilmoituksia"
	},

	"resultCount_one": "{{count}} ilmoitus",

	"resultCount_other": "{{count}} ilmoitusta",

	"resultCount_zero": "Ei aktiivisia ilmoituksia",

	"empty": {
		"title": "Ei ilmoituksia vielä",

		"description": "Yhtään kiekkoa ei ole listattu myyntiin. Ole ensimmäinen!",

		"cta": "Listaa kiekko"
	},

	"noResults": {
		"title": "Ei tuloksia",

		"description": "Mikään ilmoitus ei vastaa hakuasi.",

		"clear": "Tyhjennä suodattimet"
	},

	"flightNumbers": {
		"speed": "Nop",

		"glide": "Lii",

		"turn": "Vak",

		"fade": "Fei"
	},

	"card": {
		"condition": {
			"9": "Kuin uusi",

			"8": "Erinomainen",

			"7": "Hyvä",

			"6": "Kohtalainen",

			"5": "Kulunut",

			"1-3": "Beat"
		},

		"shipsTo": {
			"pickup-only": "Vain nouto",

			"domestic": "Kotimaahan",

			"international": "Ulkomaille"
		},

		"negotiable": "neuvot.",

		"saveToWatchlist": "Lisää seurantaan",

		"removeFromWatchlist": "Poista seurannasta"
	}
}
